import { Heart } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border/40 bg-background/50 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Brand */}
          <div className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_client-uploader/artifacts/hzwygg8f_Sticker%20Mule%20Logo2.png"
              alt="AI in Wonderland"
              className="h-8 w-8 object-contain opacity-80"
            />
            <span className="font-heading text-sm font-medium text-muted-foreground">
              AI in Wonderland
            </span>
          </div>

          {/* Copyright */}
          <p className="text-sm text-muted-foreground flex items-center gap-1.5">
            © {currentYear} AI in Wonderland. Made with
            <Heart className="h-3.5 w-3.5 text-destructive fill-destructive" />
          </p>
        </div>
      </div>
    </footer>
  );
};
